export default __webpack_public_path__ + "static/media/cateogrybanner.1c12bd01.jpeg";